var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "white-bg green-border-box outer-box" }, [
    _c("div", { staticClass: "inner-box" }, [
      _c(
        "span",
        { staticClass: "title", attrs: { title: _vm.taskDataPoint.dataPoint } },
        [_vm._v(_vm._s(_vm.taskDataPoint.data_point))]
      ),
      _c("br"),
      _c("div", { staticClass: "text-left float-left" }, [
        _c(
          "button",
          {
            staticClass: "btn-negative",
            attrs: {
              "data-target": "#delete-task-data-point-popup",
              "data-toggle": "modal",
              type: "button"
            },
            on: {
              click: function($event) {
                return _vm.$emit("loadTaskDataPointDetails", _vm.taskDataPoint)
              }
            }
          },
          [_vm._v("DELETE")]
        )
      ]),
      _c("div", { staticClass: "text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn-positive",
            attrs: {
              "data-target": "#edit-task-data-point-popup",
              "data-toggle": "modal",
              type: "button"
            },
            on: {
              click: function($event) {
                return _vm.$emit("loadTaskDataPointDetails", _vm.taskDataPoint)
              }
            }
          },
          [_vm._v("EDIT")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }